import * as React from 'react';
import { List, IList, ScrollToMode, IListProps } from 'office-ui-fabric-react/lib/List';

interface ScrollToIndexProps extends IListProps {
    scrollToIndex: number;
}

function withScrollToIndex(
    List: React.ComponentClass<IListProps>
): React.ComponentType<ScrollToIndexProps> {
    return class extends React.Component<ScrollToIndexProps> {
        private listRef: React.RefObject<IList> = React.createRef();
        private container: React.RefObject<HTMLDivElement> = React.createRef();
        private elementRefs: { [key: string]: HTMLDivElement } = {};

        componentDidMount() {
            this.scroll();
        }

        componentDidUpdate(prevProps: ScrollToIndexProps) {
            if (prevProps.scrollToIndex !== this.props.scrollToIndex) {
                this.scroll();
            }
        }

        render() {
            const { scrollToIndex, ...passThroughProps } = this.props;
            return (
                <div ref={this.container}>
                    <List
                        {...passThroughProps}
                        componentRef={this.listRef}
                        onRenderCell={this.onRenderCell}
                    />
                </div>
            );
        }

        private measureItem = (index: number) => {
            return this.elementRefs[index]
                ? this.elementRefs[index].getBoundingClientRect().height
                : 0;
        };

        private scroll = () => {
            setTimeout(
                () =>
                    this.listRef.current != null &&
                    this.listRef.current.scrollToIndex(
                        this.props.scrollToIndex,
                        this.measureItem,
                        ScrollToMode.center
                    ),
                0
            );
        };

        private onRenderCell = (
            item?: any,
            index?: number,
            isScrolling?: boolean
        ): React.ReactNode => {
            return (
                <div ref={(ref: HTMLDivElement) => (this.elementRefs[index] = ref)}>
                    {this.props.onRenderCell(item, index, isScrolling)}
                </div>
            );
        };
    };
}

export const ListWithScrollToIndex = withScrollToIndex(List);
